<template>
  <div id="sidenavSecExample">
    <div class="mb-4">
      <Link class="group flex items-center py-3" href="/">
        <icon name="dashboard" class="mr-2 w-4 h-4" :class="isUrl('') ? 'fill-white' : 'fill-gray-300 group-hover:fill-white'" />
        <div :class="isUrl('') ? 'text-white' : 'text-gray-300 group-hover:text-white'">Dashboard</div>
      </Link>
    </div>
    <div id="sidenavSecEx1" class="relative mb-4">
      <a class="flex items-center py-4 h-12 overflow-hidden text-ellipsis whitespace-nowrap rounded hover:bg-blue-50 transition duration-300 ease-in-out cursor-pointer" data-mdb-ripple="true" data-mdb-ripple-color="primary" data-bs-toggle="collapse" data-bs-target="#collapseSidenavSecEx1" aria-expanded="false" aria-controls="collapseSidenavSecEx1">
        <icon name="dashboard" class="mr-1 w-4 h-4 fill-gray-300" />
        <div class="text-bold text-lg text-gray-300">Master</div>
        <icon name="cheveron-down" class="ml-1 w-4 h-4 fill-gray-300" />
      </a>
      <ul id="collapseSidenavSecEx1" class="relative accordion-collapse collapse" aria-labelledby="sidenavSecEx1" data-bs-parent="#sidenavSecExample">
        <Link class="group flex items-center py-2 pl-2" href="/employees">
          <icon name="users" class="mr-1 w-4 h-4" :class="isUrl('employees') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div class="text-sm" :class="isUrl('employees') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Karyawan</div>
        </Link>
        <Link class="group flex items-center py-2 pl-2" href="/organizations/1">
          <icon name="donor" class="mr-1 w-4 h-4" :class="isUrl('organizations/1') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div class="text-sm" :class="isUrl('organizations/1') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Donor</div>
        </Link>
        <Link class="group flex items-center py-2 pl-2" href="/organizations/2">
          <icon name="supplier" class="mr-1 w-4 h-4" :class="isUrl('organizations/2') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div class="text-sm" :class="isUrl('organizations/2') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Supplier</div>
        </Link>
        <Link class="group flex items-center py-2 pl-2" href="/organizations/3">
          <icon name="donatur" class="mr-1 w-4 h-4" :class="isUrl('organizations/3') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div class="text-sm" :class="isUrl('organizations/3') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Donatur</div>
        </Link>
        <Link class="group flex items-center py-2 pl-2" href="/contacts">
          <icon name="contact" class="mr-1 w-4 h-4" :class="isUrl('contacts') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div class="text-sm" :class="isUrl('contacts') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Contacts</div>
        </Link>
        <Link class="group flex items-center py-2 pl-2" href="/areaprojects">
          <icon name="users" class="mr-1 w-4 h-4" :class="isUrl('areaprojects') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div class="text-sm" :class="isUrl('areaprojects') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Area Projects</div>
        </Link>
        <Link class="group flex items-center py-2 pl-2" href="/itemlocations">
          <icon name="users" class="mr-1 w-4 h-4" :class="isUrl('itemlocations') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div class="text-sm" :class="isUrl('itemlocations') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Item Locations</div>
        </Link>
        <Link class="group flex items-center py-2 pl-2" href="/units">
          <icon name="users" class="mr-1 w-4 h-4" :class="isUrl('units') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div class="text-sm" :class="isUrl('units') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Units</div>
        </Link>
        <Link class="group flex items-center py-2 pl-2" href="/items">
          <icon name="users" class="mr-1 w-4 h-4" :class="isUrl('items') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div class="text-sm" :class="isUrl('items') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Items</div>
        </Link>
        <Link class="group flex items-center py-2 pl-2" href="/sectors">
          <icon name="users" class="mr-1 w-4 h-4" :class="isUrl('items') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div class="text-sm" :class="isUrl('sectors') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Sectors</div>
        </Link>
        <Link class="group flex items-center py-2 pl-2" href="/projects">
          <icon name="printer" class="mr-1 w-4 h-4" :class="isUrl('projects', 'projectactivities') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div class="text-sm" :class="isUrl('projects', 'projectactivities') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Projects</div>
        </Link>
      </ul>
    </div>
    <div id="sidenavSecEx2" class="relative mb-4">
      <a class="flex items-center py-4 h-12 overflow-hidden text-ellipsis whitespace-nowrap rounded hover:bg-blue-50 transition duration-300 ease-in-out cursor-pointer" data-mdb-ripple="true" data-mdb-ripple-color="primary" data-bs-toggle="collapse" data-bs-target="#collapseSidenavSecEx2" aria-expanded="false" aria-controls="collapseSidenavSecEx2">
        <icon name="dashboard" class="mr-1 w-4 h-4 fill-gray-300" />
        <div class="text-bold text-lg text-gray-300">Transaksi</div>
        <icon name="cheveron-down" class="ml-1 w-4 h-4 fill-gray-300" />
      </a>
      <ul id="collapseSidenavSecEx2" class="relative accordion-collapse collapse" aria-labelledby="sidenavSecEx2" data-bs-parent="#sidenavSecExample">
        <Link class="group flex items-center py-2 pl-2" href="/logistics">
          <icon name="printer" class="mr-1 w-4 h-4" :class="isUrl('logistics') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div class="text-sm" :class="isUrl('logistics') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Sumbangan Logistik</div>
        </Link>
        <Link class="group flex items-center py-2 pl-2" href="/purchases">
          <icon name="printer" class="mr-1 w-4 h-4" :class="isUrl('purchases') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div class="text-sm" :class="isUrl('purchases') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Purchase Request</div>
        </Link>
        <Link class="group flex items-center py-2 pl-2" href="/purchaseorders">
          <icon name="printer" class="mr-1 w-4 h-4" :class="isUrl('purchaseorders') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div class="text-sm" :class="isUrl('purchaseorders') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Purchase Orders</div>
        </Link>

        <Link class="group flex items-center py-2 pl-2" href="/porecv">
          <icon name="printer" class="mr-1 w-4 h-4" :class="isUrl('porecv') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div class="text-sm" :class="isUrl('porecv') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Penerimaan Barang PO</div>
        </Link>
        <Link class="group flex items-center py-2 pl-2" href="/stockouts">
          <icon name="printer" class="mr-1 w-4 h-4" :class="isUrl('stockouts') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div class="text-sm" :class="isUrl('stockouts') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Pengeluaran Barang</div>
        </Link>
      </ul>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'

export default {
  components: {
    Icon,
    Link,
  },
  methods: {
    isUrl(...urls) {
      let currentUrl = this.$page.url.substr(1)
      if (urls[0] === '') {
        return currentUrl === ''
      }
      return urls.filter((url) => currentUrl.startsWith(url)).length
    },
  },
}
</script>
